import { QuestionnaireItemType } from "../../_helpers";


export const DEFAULT_QUESTION = {
  title: "",
  description: "",
  questions: [
    { 
      text: "",
      type: QuestionnaireItemType.Radio,
      required: false,
      options: [{option: ""}],
    },
  ],
};